import React from "react";
import { Modal, Button } from "react-bootstrap";

const DamageDetailModal = ({ show, onHide, categories }) => {
  if (!categories) return null;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Damage Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Name:</strong> {categories.name}
        </p>
        <p>
          <strong>Comment:</strong> {categories.comment}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DamageDetailModal;
